export const validateSendTypingActivityParams = (sessionId, typing) => {
  if (!sessionId) {
    return new Error('A conversationId must be provided.');
  }

  if (typeof typing !== 'boolean') {
    return new Error('Typing status must be a boolean');
  }

  return undefined;
};
